<script setup lang="ts">
import { propTypes } from '@/utils/propTypes';
import { computed, CSSProperties, useSlots } from 'vue'
import { ElIcon } from 'element-plus';
import { Loading } from '@element-plus/icons-vue'

const slots = useSlots()
const emit = defineEmits(['click'])
const props = defineProps({
  type: propTypes.string.def('default'),
  plain: propTypes.bool.def(false),
  size: propTypes.string.def('small'),
  filled: propTypes.bool.def(true),
  active: propTypes.bool.def(false),
  disable: propTypes.bool.def(false),
  icon: propTypes.string.def(''),
  loading: propTypes.bool.def(false),
  disableTips: propTypes.string.def(''),
  text: propTypes.bool.def(false),
  effects: propTypes.bool.def(true)
  // height: propTypes.string.def('32px'),
  // bgColor: propTypes.string.def('var(--left-menu-text-active-color)'),
  // borderColor: propTypes.string.def('var(--left-menu-text-active-color)'), // 只有plain模式下才会生效
  // borderRadius: propTypes.string.def('4px'),
  // textColor: propTypes.string.def(''),
  // fontSize: propTypes.string.def('14px'),
  // fontBold: propTypes.bool.def(true),
  // padding: propTypes.string.def('0px 8px'),
  // spacing: propTypes.string.def('6px'),
  // plain: propTypes.bool.def(false),
  // disable: propTypes.bool.def(false),
  // loading: propTypes.bool.def(false)
})

const click = (e) => { 
   
  if(props.disable){
      if(props.disableTips){
          // this.$message(props.disableTips);
      }
      return
  }
  emit('click',e)
  // if(props.nobubble){
  //     if(window.event){
  //         window.event.cancelBubble = true
  //         e.preventDefault()
  //     }else{
  //         e.preventDefault()
  //     }
  // }  
}
// const style = computed(():CSSProperties => {
//   return {
//     height: props.height,
//     backgroundColor: props.plain?'var(--c-white)':props.bgColor,
//     border: props.plain?'1px solid '+props.borderColor:'',
//     // 如果给定color了就用给定的，如果没给color但是plain模式，则与boder一致
//     borderRadius: props.borderRadius,
//     color: props.textColor?props.textColor:props.plain?props.borderColor:'var(--c-white)',
//     fontSize: props.fontSize,
//     fontWeight: props.fontBold?'bold':'normal',
//     padding: props.padding,
//     pointerEvents: props.disable?'none':'auto'
//   }
// })
const classStr = computed(() => {
    var arr = ['c-button']
    arr.push('c-button-'+props.type)
    arr.push('c-button-'+props.size)
    if(props.active){
        arr.push(`c-button-${props.type}-active`)
    }
    if(props.text){
      arr.push(`c-button-${props.type}-text`) 
    }else if(props.plain){
        arr.push(`c-button-${props.type}-plain`)
    }else if(props.filled){
        arr.push(`c-button-${props.type}-filled`)
    } 
    if(props.disable){
        arr.push(`c-button-disable`)
    }
    if(!props.effects){
        arr.push('no-effects')
    }                      
    return arr;
})
const iconStr = computed(() => {
  switch (props.icon) {
      case 'add':
          return '&#xe613;'                
      case 'delete':
          return '&#xe607;'
      case 'export':
          return '&#xe644;'
      case 'import':
          return '&#xe60a;'                    
      default:
          return ''
  }
})
</script>

<template>
    <button type="button" :class="classStr" :style="loading?'pointer-events: none;':''" @click="click">
      <span>
          <i v-if="icon" class="icon iconfont" v-html="iconStr">
          </i>
          <slot></slot>
      </span>
      <div v-if="loading" class="loading-mask">
        <el-icon class="is-loading">
          <Loading />
        </el-icon>
      </div>
  </button>  
  <!-- <div class="c-button" :style="style">
    <div>
      <i v-if="icon" class="icon iconfont" v-html="iconStr"></i>    
      <slot name="prefix" ></slot>
    </div>
    <div :style="{lineHeight: height}" class="cont">
      <slot></slot>
    </div> 
  </div> -->
</template>

<style lang="less" scoped>
  // .spm-button {
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   box-sizing: border-box;
  //   padding: 0px 8px;
  //   border-radius: 2px;
  //   cursor: pointer;
  //   position: relative;    
  //   .btn-loading-mask{
  //     position: absolute;
  //     top:0;
  //     left:0;
  //     width: 100%;
  //     height: 100%;
  //     // background-color: rgba(255,255,255,.8);
  //     border-radius: 4px;
  //     display: flex;
  //     align-items: center;
  //     justify-content: center;
  //     pointer-events: none;    
  //     .btn-loading-icon{
  //       content: url('@/assets/icons/icon-loading.svg');
  //       width: 32px;
  //       height: 32px;
  //       display: block;
  //       // content: url('~@/assets/icons/img_login_loading.svg');
  //       -webkit-transform: rotate(360deg);
  //       transform: rotate(360deg);
  //       animation: rotation 1.5s linear infinite;
  //       -moz-animation: rotation 1.5s linear infinite;
  //       -webkit-animation: rotation 1.5s linear infinite;
  //       -o-animation: rotation 1.5s linear infinite;         
  //     }
  //     @keyframes rotation {
  //       from {
  //         transform: rotate(0deg);
  //       }
  //       to {
  //         transform: rotate(360deg);
  //       }
  //     }
  //     @-webkit-keyframes rotation {
  //       from {
  //         -webkit-transform: rotate(0deg);
  //       }
  //       to {
  //         -webkit-transform: rotate(360deg);
  //       }
  //     }    
  //   }
  // }
  .c-button{
    display: inline-block;
    border-radius: 4px;
    font-size: 15px;
    transition: .1s;    
    line-height: 24;
    cursor: pointer;
    border: 1px solid var(--c-btn-normal);
    background: transparent;
    color: var(--c-btn-normal);
    text-align: center;
    box-sizing: border-box;
    margin: 0;
    font-weight: 700;
    padding: 4px 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    outline:none; 
    position: relative;
    box-sizing: border-box;    
    font-family:"Microsoft JhengHei";
    height: 32px;
    flex-shrink: 0;
    flex-grow: 0;
    i{
        font-weight: 700;
    }
    .iconfont{
        font-weight: 400;
        font-size: 20px;
    }
    &>span{
        line-height: 20px;
        // height: 100%;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 4px;
    }
    .loading-mask{
        position: absolute;
        top:0;
        left:0;
        width: 100%;
        height: 100%;
        background-color: var(--c-btn-mask);
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        pointer-events: none;
    }
    &.c-button-disable{
        cursor: not-allowed;
        pointer-events: none;
        opacity: 0.3;
    }  
    &-primary{
        border:1px solid var(--c-btn-primary);
        color: var(--c-btn-primary);
        background: var(--c-btn-plain-bg);
        &:hover:not(.no-effects){
            background: var(--c-btn-primary-light);
        }
        &:active:not(.no-effects),&-active:not(.no-effects){
            color: var(--c-btn-fill-tx);
            background: var(--c-btn-primary);
            border: none;
        }
        .loading-mask{
            color: var(--c-btn-primary);
        }
        &-text{
            color: var(--c-btn-primary);
            background: none;
            box-shadow:none;
            border: none;
            font-size: 16px;
            font-weight: 700;
            &:hover:not(.no-effects){
                color: var(--c-btn-primary);
                background: var(--c-btn-primary-light);
            }
            &:active:not(.no-effects){
                color: var(--c-btn-fill-tx);
                background: var(--c-btn-primary);
            }                         
        }
        &-filled{
            color: var(--c-btn-fill-tx);
            background: var(--c-btn-primary);
            box-shadow:none;
            border: none;
            .loading-mask{
                color: var(--c-btn-primary);
            }
            &:hover:not(.no-effects){
                color: var(--c-btn-primary);
                background: var(--c-btn-primary-light);
            }
            &:active:not(.no-effects){
                color: var(--c-btn-fill-tx);
                background: var(--c-btn-primary);
            }
        }        
    }
    &-success{
        border:1px solid var(--c-btn-succeed);
        color: var(--c-btn-succeed);
        background: var(--c-btn-plain-bg);
        &:hover:not(.no-effects){
            background: var(--c-btn-succeed-light);
        }
        &:active:not(.no-effects),&-active:not(.no-effects){
            color: var(--c-btn-fill-tx);
            background: var(--c-btn-succeed-dark);
        }
        .loading-mask{
            color: var(--c-btn-succeed);
        }
        &-text{
            color: var(--c-btn-succeed);
            background: none;
            box-shadow:none;
            border: none;
            font-weight: 700;
            font-size: 16px;
            &:hover:not(.no-effects){
                color: var(--c-btn-succeed);
                background: var(--c-btn-succeed-light);
            }
            &:active:not(.no-effects){
                color: var(--c-btn-fill-tx);
                background: var(--c-btn-succeed-dark);
            }                         
        }        
        &-filled{
            color: var(--c-btn-fill-tx);
            background: var(--c-btn-succeed);
            box-shadow:none;
            border: none;
            .loading-mask{
                color: var(--c-btn-succeed);
            }
            &:hover:not(.no-effects){
                color: var(--c-btn-succeed);
                background: var(--c-btn-succeed-light);
            }
            &:active:not(.no-effects){
                color: var(--c-btn-fill-tx);
                background: var(--c-btn-succeed-dark);
            }
        } 
    }
    &-warning{
        border:1px solid var(--c-btn-warn);
        color: var(--c-btn-warn);
        background: var(--c-btn-plain-bg);
        &:hover:not(.no-effects){
            background: var(--c-btn-warn-light);
        }
        &:active:not(.no-effects),&-active:not(.no-effects){
            color: var(--c-btn-fill-tx);
            background: var(--c-btn-warn-dark);
        }
        .loading-mask{
            color: var(--c-btn-warn);
        }
        &-text{
            color: var(--c-btn-warn);
            background: none;
            box-shadow:none;
            border: none;
            font-size: 16px;
            font-weight: 700;
            &:hover:not(.no-effects){
                color: var(--c-btn-warn);
                background: var(--c-btn-warn-light);
            }
            &:active:not(.no-effects){
                color: var(--c-btn-fill-tx);
                background: var(--c-btn-warn-dark);
            }                         
        }         
        &-filled{
            color: var(--c-btn-fill-tx);
            background: var(--c-btn-warn);
            box-shadow:none;
            border: none;
            .loading-mask{
                color: var(--c-btn-warn);
            }
            &:hover:not(.no-effects){
                color: var(--c-btn-warn);
                background: var(--c-btn-warn-light);
            }
            &:active:not(.no-effects){
                color: var(--c-btn-fill-tx);
                background: var(--c-btn-warn-dark);
            }
        } 
    }   
    &-danger{
        border:1px solid var(--c-btn-danger);
        color: var(--c-btn-danger);
        background: var(--c-btn-plain-bg);
        &:hover:not(.no-effects){
            background: var(--c-btn-danger-light);
        }
        &:active:not(.no-effects),&-active:not(.no-effects){
            color: var(--c-btn-fill-tx);
            background: var(--c-btn-danger-dark);
        }
        .loading-mask{
            color: var(--c-btn-danger);
        }
        &-text{
            color: var(--c-btn-danger);
            background: none;
            box-shadow:none;
            border: none;
            font-size: 16px;
            font-weight: 700;
            &:hover:not(.no-effects){
                color: var(--c-btn-danger);
                background: var(--c-btn-danger-light);
            }
            &:active:not(.no-effects){
                color: var(--c-btn-fill-tx);
                background: var(--c-btn-danger-dark);
            }                         
        }        
        &-filled{
            color: var(--c-btn-fill-tx);
            background: var(--c-btn-danger);
            box-shadow:none;
            border: none;
            .loading-mask{
                color: var(--c-btn-danger);
            }
            &:hover:not(.no-effects){
                color: var(--c-btn-danger);
                background: var(--c-btn-danger-light);
            }
            &:active:not(.no-effects){
                color: var(--c-btn-fill-tx);
                background: var(--c-btn-danger-dark);
            }
        } 
    }
    &-cancel,&-default{
        border:1px solid var(--c-btn-normal);
        color: var(--c-btn-normal);
        background: var(--c-btn-plain-bg);
        &:hover:not(.no-effects){
            background: var(--c-btn-normal-light);
        }
        &:active:not(.no-effects),&-active:not(.no-effects){
            color: var(--c-btn-fill-tx);
            background: var(--c-btn-normal-dark);
        }
        .loading-mask{
            color: var(--c-btn-normal);
        }
        &-text{
            color: var(--c-btn-normal);
            background: none;
            box-shadow:none;
            border: none;
            font-size: 16px;
            font-weight: 700;
            &:hover:not(.no-effects){
                color: var(--c-btn-normal);
                background: var(--c-btn-normal-light);
            }
            &:active:not(.no-effects){
                color: var(--c-btn-fill-tx);
                background: var(--c-btn-normal-dark);
            }                         
        }        
        &-filled{
            color: var(--c-btn-fill-tx);
            background: var(--c-btn-normal);
            box-shadow:none;
            border: none;
            .loading-mask{
                color: var(--c-btn-normal);
            }
            &:hover:not(.no-effects){
                color: var(--c-btn-normal);
                background: var(--c-btn-normal-light);
            }
            &:active:not(.no-effects){
                color: var(--c-btn-fill-tx);
                background: var(--c-btn-normal-dark);
            }
        } 
    }      
    &-medium{
        font-size: 15px;
        min-width: 80px;
        padding: 4px 8px;
    }
    &-small{
        font-size: 15px;
        min-width: 72px;
        padding: 4px 8px;
    }    
    &-mini{
        font-size: 12px;
        padding: 4px 8px;
        border-radius: 3px;  
        min-width: auto;
        .loading-mask{
            border-radius: 3px; 
        }              
    }
}  
</style>